import React, { useContext } from 'react';
import { Form } from 'semantic-ui-react';
import _compact from 'lodash/compact';
import _values from 'lodash/values';
import { ChildrenPropType } from '../../../../../foundation/types/component';
import { ItemCartContext } from '../../CatalogItemCart.context';
var defaultProps = {
  children: /*#__PURE__*/React.createElement("span", null, "Add to Cart"),
  disabled: false
};
function AddToCartButton(_ref) {
  var children = _ref.children,
    disabledProp = _ref.disabled;
  var _useContext = useContext(ItemCartContext),
    formErrors = _useContext.formErrors,
    loading = _useContext.loading,
    touched = _useContext.touched;
  var hasErrors = !!_compact(_values(formErrors)).length;
  var disabled = disabledProp || hasErrors && touched;
  return /*#__PURE__*/React.createElement(Form.Button, {
    primary: true,
    className: "add-to-cart-button",
    disabled: disabled,
    loading: loading,
    type: "submit"
  }, children);
}
AddToCartButton.defaultProps = defaultProps;
export default AddToCartButton;